module.exports = __webpack_public_path__ + "img/welcome-graphic.1010e88f.png";